export const centsToPesos = (cents) => {
  return parseFloat(cents) / 100 || 0;
};

// Converts cents to formatted currency string (legacy - maintained for compatibility)
export const centsToCurrencyString = cents => {
  const parts = (cents/100).toFixed(2).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return '$' + parts.join(".");
};

export const formatPrice = (priceInCents, locale = 'es-MX', currency = 'MXN') => {
  const price = centsToPesos(priceInCents);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(price);
};

export const calculateItemsTotal = (items = []) => {
  return items.reduce((total, item) => {
    const price = centsToPesos(item.price);
    const quantity = parseInt(item.quantity) || 1;
    return total + (price * quantity);
  }, 0);
};

export const toRad = n => n * Math.PI / 180;